import {ChangeDetectionStrategy, Component} from "@angular/core";


@Component({
    selector: 'inline-skjema-tittel',
    template: '<ng-content/>',
    styleUrls: ['./inline-skjema-tittel.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineSkjemaTittelKomponent {

}
